export enum QuestInfoFlags {
    Rare = 0x1,
    Elite = 0x2,
    Epic = 0x4,
    HiddenInQuestLog = 0x10,
}
